// MEASUREMENT FREQUENCY
export const GET_MEASUREMENT_FREQUENCIES = '/measurement_frequency/query';
export const GET_MEASUREMENT_FREQUENCY = '/measurement_frequency/';
export const POST_MEASUREMENT_FREQUENCY = '/measurement_frequency/';
export const PUT_MEASUREMENT_FREQUENCY = '/measurement_frequency/';
export const DELETE_MEASUREMENT_FREQUENCY = '/measurement_frequency/';
export const CHECK_MEASUREMENT_FREQUENCY_EXISTS = '/measurement_frequency/query';
